var _path;

import * as React from "react";

function SvgAlarmClock(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C12.267 8 6 14.268 6 22c0 3.02.98 5.96 2.797 8.374l-2.506 2.505a1 1 0 000 1.415l1.415 1.413a1 1 0 001.413 0l2.506-2.507a13.926 13.926 0 0016.75 0l2.506 2.505a1 1 0 001.414 0l1.414-1.413a1 1 0 000-1.415L31.2 30.374a13.918 13.918 0 002.8-8.375c0-7.731-6.27-14-14-14zm0 24.999a11 11 0 110-22 11 11 0 010 22zM10 4a6 6 0 00-6 6 5.925 5.925 0 00.957 3.203l9.118-7.598A5.977 5.977 0 0010.001 4zm11.5 18.279v-7.78a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v8.26a2 2 0 00.75 1.563l4.034 3.223c.105.08.235.117.367.107a.5.5 0 00.334-.184l1.25-1.563a.5.5 0 00-.078-.704L21.5 22.279zM30 4a5.979 5.979 0 00-4.074 1.604l9.118 7.597c.619-.953.95-2.065.955-3.201a6 6 0 00-6-6z"
  })));
}

export default SvgAlarmClock;